import { StarFill, StarHalfFill, StarNoFill } from '../assets'
import styles from './star-rating.module.css'

export interface StarRatingProps {
  starRating: number
}

export const StarRating: React.FC<StarRatingProps> = ({ starRating }) => {
  const stars = [...Array.from({ length: 5 }).keys()]

  const starComponents: JSX.Element[] = stars.map((_, index) => {
    const starNumber = index + 1
    const idPrefix = `star-${starRating}-${starNumber}`

    const isFilled = starNumber <= Math.floor(starRating / 2)
    const isHalf =
      starNumber === Math.ceil(starRating / 2) && starRating % 2 !== 0

    return isFilled ? (
      <StarFill key={starNumber} />
    ) : isHalf ? (
      <StarHalfFill key={starNumber} idPrefix={idPrefix} />
    ) : (
      <StarNoFill key={starNumber} />
    )
  })

  return <div className={styles.starRatingContainer}>{starComponents}</div>
}
